// // src/pages/FileDetailPage.tsx
// import React, { useCallback, useEffect, useMemo, useState } from "react";
// import {
//   Box,
//   Paper,
//   Stack,
//   Typography,
//   Chip,
//   TextField,
//   IconButton,
//   Button,
//   Alert,
//   CircularProgress,
//   Divider,
// } from "@mui/material";
// import ArrowBackIcon from "@mui/icons-material/ArrowBack";
// import SaveIcon from "@mui/icons-material/Save";
// import AddIcon from "@mui/icons-material/Add";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import DescriptionIcon from "@mui/icons-material/Description";

// import { useNavigate, useParams } from "react-router-dom";
// import axios from "axios";
// import type { RawAxiosRequestHeaders } from "axios";

// import { API_BASE } from "../services/api";
// import type { ApiResponse } from "../types/api-response";
// import type { FileRow, FileResourceIndex } from "../types/file";

// // ✅ UTC+0 기준 포맷터 (Dashboard / FileItemCard와 동일 컨셉)
// const formatUtc = (value?: string | null) => {
//   if (!value) return "";
//   const d = new Date(value);
//   if (isNaN(d.getTime())) return String(value);

//   const pad = (n: number) => String(n).padStart(2, "0");

//   const year = d.getUTCFullYear();
//   const month = pad(d.getUTCMonth() + 1);
//   const day = pad(d.getUTCDate());
//   const hour = pad(d.getUTCHours());
//   const minute = pad(d.getUTCMinutes());
//   const second = pad(d.getUTCSeconds());

//   return `${year}-${month}-${day} ${hour}:${minute}:${second} (UTC+0)`;
// };

// interface HeadingRow {
//   id: string;
//   title: string;
//   page: number;
// }

// // v_files_with_uploader 뷰 제거로 인한 타입 단순화 (기존 필드 유지하되 optional 처리)
// interface FileRowWithUploader extends FileRow {
//   // uploader_tier 정보는 이제 DB에서 오지 않으므로 사용하지 않음
//   uploader_tier?: number | null; 
//   uploader_org_id?: string | null;
// }

// const FileDetailPage: React.FC = () => {
//   const { fileId } = useParams<{ fileId: string }>();
//   const navigate = useNavigate();

//   const [fileMeta, setFileMeta] = useState<FileRowWithUploader | null>(null);
//   const [resource, setResource] = useState<FileResourceIndex | null>(null);

//   const [loading, setLoading] = useState(false);
//   const [saving, setSaving] = useState(false);
//   const [error, setError] = useState<string | null>(null);
//   const [saveMessage, setSaveMessage] = useState<string | null>(null);

//   // heading_json 편집용 로컬 상태
//   const [headingRows, setHeadingRows] = useState<HeadingRow[]>([]);

//   // 내 정보 (로컬 스토리지)
//   const userId = localStorage.getItem("user_id");
//   const myTier = useMemo(() => {
//     const t = localStorage.getItem("tier");
//     return t ? Number(t) : null;
//   }, []);

//   const getHeaders = useCallback((): RawAxiosRequestHeaders => {
//     const user_id = localStorage.getItem("user_id") || "";
//     const access_token = localStorage.getItem("access_token") || "";
//     const refresh_token = localStorage.getItem("refresh_token") || "";
//     return {
//       "x-user-id": user_id,
//       "x-access-token": access_token,
//       "x-refresh-token": refresh_token,
//     };
//   }, []);

//   // heading_json → HeadingRow[] 로 변환
//   const headingJsonToRows = useCallback(
//     (heading_json: Record<string, number> | null | undefined): HeadingRow[] => {
//       if (!heading_json) return [];
//       return Object.entries(heading_json).map(([title, page]) => ({
//         id: `${title}__${page}__${Math.random().toString(36).slice(2, 8)}`,
//         title,
//         page,
//       }));
//     },
//     []
//   );

//   // ✅ HeadingRow[] → heading_json 으로 되돌리기
//   const rowsToHeadingJson = (rows: HeadingRow[]): Record<string, number> => {
//     const obj: Record<string, number> = {};
//     for (const r of rows) {
//       const key = r.title.trim();
//       if (!key) continue;
//       const pageNum = Number(r.page);
//       if (!pageNum || pageNum <= 0) continue;
//       obj[key] = pageNum;
//     }
//     return obj;
//   };

//   // 데이터 로드
//   useEffect(() => {
//     const fetchAll = async () => {
//       if (!fileId) return;
//       setLoading(true);
//       setError(null);
//       setSaveMessage(null);
//       try {
//         // 1) 파일 메타
//         const metaRes = await axios.get<ApiResponse<FileRowWithUploader>>(
//           `${API_BASE}files/${fileId}`,
//           { headers: getHeaders() }
//         );

//         if (!metaRes.data.success || !metaRes.data.data) {
//           throw new Error(
//             metaRes.data.error ||
//               metaRes.data.message ||
//               "파일 정보를 불러오지 못했습니다."
//           );
//         }
//         setFileMeta(metaRes.data.data);

//         // 2) resource_index
//         const riRes = await axios.get<ApiResponse<FileResourceIndex>>(
//           `${API_BASE}files/${fileId}/resource-index`,
//           { headers: getHeaders() }
//         );

//         if (!riRes.data.success || !riRes.data.data) {
//           throw new Error(
//             riRes.data.error ||
//               riRes.data.message ||
//               "resource_index 정보를 불러오지 못했습니다."
//           );
//         }
//         setResource(riRes.data.data);

//         // heading_json 편집용 세팅
//         setHeadingRows(headingJsonToRows(riRes.data.data.heading_json));
//       } catch (e: any) {
//         setError(e?.message || "데이터를 불러오지 못했습니다.");
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchAll();
//   }, [fileId, getHeaders, headingJsonToRows]);

//   // 🚫 권한 체크 로직 수정 (Tier 1/2 격리 정책 반영)
//   const headingReadOnly = useMemo(() => {
//     if (!fileMeta) return true; // 로딩 중에는 편집 불가 취급
//     if (myTier === null) return true;
    
//     // Tier 0 (관리자) -> 모든 파일 편집 가능
//     if (myTier === 0) return false;

//     // Tier 1, 2 (일반 팀원) -> 본인이 올린 파일만 편집 가능
//     // (GLOBAL 파일이나 관리자 파일은 읽기 전용)
//     if (fileMeta.uploader_id !== userId) {
//       return true;
//     }

//     return false;
//   }, [fileMeta, myTier, userId]);

//   // heading 행 변경 핸들러
//   const handleHeadingChange = (
//     id: string,
//     field: "title" | "page",
//     value: string
//   ) => {
//     if (headingReadOnly) return;
//     setHeadingRows((prev) =>
//       prev.map((row) =>
//         row.id === id
//           ? {
//               ...row,
//               [field]: field === "page" ? Number(value) || 0 : value,
//             }
//           : row
//       )
//     );
//   };

//   const handleAddHeadingRow = () => {
//     if (headingReadOnly) return;
//     setHeadingRows((prev) => [
//       ...prev,
//       {
//         id: `new_${Date.now()}`,
//         title: "",
//         page: 1,
//       },
//     ]);
//   };

//   const handleRemoveHeadingRow = (id: string) => {
//     if (headingReadOnly) return;
//     setHeadingRows((prev) => prev.filter((row) => row.id !== id));
//   };

//   const handleSaveHeading = async () => {
//     if (!fileId) return;
//     if (headingReadOnly) return; // 방어 로직
//     setSaving(true);
//     setError(null);
//     setSaveMessage(null);
//     try {
//       const heading_json = rowsToHeadingJson(headingRows);

//       await axios.put<ApiResponse>(
//         `${API_BASE}files/${fileId}/heading-json`,
//         { heading_json },
//         { headers: getHeaders() }
//       );

//       setSaveMessage("heading_json이 저장되었습니다.");
//     } catch (e: any) {
//       setError(e?.message || "heading_json 저장에 실패했습니다.");
//     } finally {
//       setSaving(false);
//     }
//   };

//   const contentPreview = useMemo(() => {
//     if (!resource?.content_string_list) return [];
//     return resource.content_string_list.map((text, idx) => {
//       const trimmed = text ?? "";
//       const slice =
//         trimmed.length > 100 ? trimmed.slice(0, 100) + "…" : trimmed;
//       return {
//         index: idx,
//         preview: slice,
//       };
//     });
//   }, [resource]);

//   return (
//     <Box sx={{ p: 2 }}>
//       {/* 상단 헤더 */}
//       <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2 }}>
//         <IconButton onClick={() => navigate(-1)} size="small">
//           <ArrowBackIcon />
//         </IconButton>
//         <Typography variant="h6" sx={{ fontWeight: 800 }}>
//           파일 상세
//         </Typography>
//         <Box sx={{ flexGrow: 1 }} />
//         {fileMeta?.status && (
//           <Chip label={fileMeta.status} size="small" variant="outlined" />
//         )}
//       </Stack>

//       {error && (
//         <Alert severity="error" sx={{ mb: 2 }}>
//           {error}
//         </Alert>
//       )}
//       {saveMessage && (
//         <Alert severity="success" sx={{ mb: 2 }}>
//           {saveMessage}
//         </Alert>
//       )}

//       {loading ? (
//         <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}>
//           <CircularProgress />
//         </Box>
//       ) : (
//         fileMeta &&
//         resource && (
//           <Stack spacing={2}>
//             {/* 파일 메타 정보 카드 */}
//             <Paper variant="outlined" sx={{ p: 2 }}>
//               <Stack
//                 direction="row"
//                 spacing={1}
//                 alignItems="center"
//                 sx={{ mb: 1 }}
//               >
//                 <DescriptionIcon fontSize="small" />
//                 <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
//                   v{fileMeta.version_no} · {fileMeta.original_name}
//                 </Typography>
//                 <Chip
//                   label={
//                     (fileMeta.version_kind || "").toLowerCase() === "patch"
//                       ? "PATCH"
//                       : "FULL"
//                   }
//                   size="small"
//                   color={
//                     (fileMeta.version_kind || "").toLowerCase() === "patch"
//                       ? "warning"
//                       : "primary"
//                   }
//                   sx={{ ml: 1 }}
//                 />
//                 <Box sx={{ flexGrow: 1 }} />
//               </Stack>

//               <Stack direction="row" spacing={1} flexWrap="wrap">
//                 {fileMeta.effective_date && (
//                   <Chip
//                     size="small"
//                     variant="outlined"
//                     label={`effective: ${formatUtc(fileMeta.effective_date)}`}
//                   />
//                 )}
//                 {fileMeta.uploaded_at && (
//                   <Chip
//                     size="small"
//                     variant="outlined"
//                     label={`uploaded: ${formatUtc(fileMeta.uploaded_at)}`}
//                   />
//                 )}
//                 <Chip
//                   size="small"
//                   variant="outlined"
//                   label={`pages: ${resource.total_page_count}`}
//                 />
//                 <Chip
//                   size="small"
//                   variant="outlined"
//                   label={`processed: ${resource.current_page_progress}/${resource.total_page_count}`}
//                 />
                
//                 {/* 관리자 소유 문서 표시 (Tier 1/2인 경우) */}
//                 {myTier !== 0 && fileMeta.uploader_id !== userId && (
//                   <Chip
//                     size="small"
//                     variant="outlined"
//                     color="warning"
//                     label="읽기 전용 (관리자/공용 문서)"
//                   />
//                 )}
//               </Stack>
//             </Paper>

//             {/* heading_json 편집 섹션 */}
//             <Paper variant="outlined" sx={{ p: 2 }}>
//               <Stack
//                 direction="row"
//                 alignItems="center"
//                 spacing={1}
//                 sx={{ mb: 1 }}
//               >
//                 <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
//                   Heading (outline) 편집
//                 </Typography>
//                 <Box sx={{ flexGrow: 1 }} />
//                 {!headingReadOnly && (
//                   <Button
//                     size="small"
//                     startIcon={<AddIcon />}
//                     onClick={handleAddHeadingRow}
//                   >
//                     행 추가
//                   </Button>
//                 )}
//                 <Button
//                   size="small"
//                   variant="contained"
//                   startIcon={<SaveIcon />}
//                   onClick={handleSaveHeading}
//                   disabled={headingReadOnly || saving}
//                 >
//                   {saving ? "저장 중..." : "heading_json 저장"}
//                 </Button>
//               </Stack>

//               {headingReadOnly && (
//                 <Alert severity="info" sx={{ mb: 2 }}>
//                   권한이 없어 목차를 수정할 수 없습니다. (읽기 전용)
//                 </Alert>
//               )}

//               {headingRows.length === 0 && (
//                 <Typography variant="body2" color="text.secondary">
//                   현재 heading_json이 없습니다.{" "}
//                   {headingReadOnly
//                     ? "설정된 목차가 없습니다."
//                     : "행을 추가해서 책갈피/목차 정보를 입력할 수 있습니다."}
//                 </Typography>
//               )}

//               <Stack spacing={1} sx={{ mt: 1 }}>
//                 {headingRows.map((row) => (
//                   <Stack
//                     key={row.id}
//                     direction={{ xs: "column", sm: "row" }}
//                     spacing={1}
//                     alignItems={{ xs: "flex-start", sm: "center" }}
//                   >
//                     <TextField
//                       label="제목"
//                       size="small"
//                       fullWidth
//                       value={row.title}
//                       onChange={(e) =>
//                         handleHeadingChange(row.id, "title", e.target.value)
//                       }
//                       InputProps={{
//                         readOnly: headingReadOnly,
//                       }}
//                     />
//                     <TextField
//                       label="페이지 번호"
//                       size="small"
//                       type="number"
//                       sx={{ width: 140 }}
//                       value={row.page}
//                       onChange={(e) =>
//                         handleHeadingChange(row.id, "page", e.target.value)
//                       }
//                       InputProps={{
//                         readOnly: headingReadOnly,
//                       }}
//                     />
//                     {!headingReadOnly && (
//                       <IconButton
//                         size="small"
//                         color="error"
//                         onClick={() => handleRemoveHeadingRow(row.id)}
//                       >
//                         <DeleteOutlineIcon fontSize="small" />
//                       </IconButton>
//                     )}
//                   </Stack>
//                 ))}
//               </Stack>
//             </Paper>

//             {/* content_string_list 100자 프리뷰 섹션 */}
//             <Paper variant="outlined" sx={{ p: 2 }}>
//               <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
//                 내용 청크 프리뷰 (앞 100자, 조회용)
//               </Typography>
//               <Typography variant="caption" color="text.secondary">
//                 page_number_list / chunk_index_list는 내부 인덱싱용으로 숨겨두고,
//                 여기서는 텍스트 청크의 일부만 조회용으로 보여줍니다.
//               </Typography>

//               <Box sx={{ mt: 1, maxHeight: "400px", overflowY: "auto" }}>
//                 {contentPreview.map((c) => (
//                   <Box key={c.index}>
//                     <Divider sx={{ my: 1 }} />
//                     <Typography variant="caption" color="text.secondary">
//                       #{c.index}
//                     </Typography>
//                     <Typography
//                       variant="body2"
//                       sx={{ whiteSpace: "pre-wrap" }}
//                     >
//                       {c.preview}
//                     </Typography>
//                   </Box>
//                 ))}

//                 {contentPreview.length === 0 && (
//                   <Typography
//                     variant="body2"
//                     color="text.secondary"
//                     sx={{ mt: 1 }}
//                   >
//                     content_string_list가 비어 있습니다. 파일 파이프라인이 아직
//                     완료되지 않았거나 오류가 발생했을 수 있습니다.
//                   </Typography>
//                 )}
//               </Box>
//             </Paper>
//           </Stack>
//         )
//       )}
//     </Box>
//   );
// };

// export default FileDetailPage;

// src/pages/FileDetailPage.tsx
import React, { useCallback, useEffect, useMemo, useState } from "react";
import {
  Box,
  Paper,
  Stack,
  Typography,
  Chip,
  TextField,
  IconButton,
  Button,
  Alert,
  CircularProgress,
  Divider,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SaveIcon from "@mui/icons-material/Save";
import AddIcon from "@mui/icons-material/Add";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import DescriptionIcon from "@mui/icons-material/Description";

import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import type { RawAxiosRequestHeaders } from "axios";

import { API_BASE } from "../services/api";
import type { ApiResponse } from "../types/api-response";
import type { FileRow, FileResourceIndex } from "../types/file";

const formatUtc = (value?: string | null) => {
  if (!value) return "";
  const d = new Date(value);
  if (isNaN(d.getTime())) return String(value);
  const pad = (n: number) => String(n).padStart(2, "0");
  const year = d.getUTCFullYear();
  const month = pad(d.getUTCMonth() + 1);
  const day = pad(d.getUTCDate());
  const hour = pad(d.getUTCHours());
  const minute = pad(d.getUTCMinutes());
  const second = pad(d.getUTCSeconds());
  return `${year}-${month}-${day} ${hour}:${minute}:${second} (UTC+0)`;
};

interface HeadingRow {
  id: string;
  title: string;
  page: number;
}

interface FileRowWithUploader extends FileRow {
  uploader_tier?: number | null; 
  uploader_org_id?: string | null;
}

const FileDetailPage: React.FC = () => {
  const { fileId } = useParams<{ fileId: string }>();
  const navigate = useNavigate();

  const [fileMeta, setFileMeta] = useState<FileRowWithUploader | null>(null);
  const [resource, setResource] = useState<FileResourceIndex | null>(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [saveMessage, setSaveMessage] = useState<string | null>(null);
  const [headingRows, setHeadingRows] = useState<HeadingRow[]>([]);

  const userId = localStorage.getItem("user_id");
  const myTier = useMemo(() => {
    const t = localStorage.getItem("tier");
    return t ? Number(t) : null;
  }, []);

  const getHeaders = useCallback((): RawAxiosRequestHeaders => {
    const user_id = localStorage.getItem("user_id") || "";
    const access_token = localStorage.getItem("access_token") || "";
    const refresh_token = localStorage.getItem("refresh_token") || "";
    return {
      "x-user-id": user_id,
      "x-access-token": access_token,
      "x-refresh-token": refresh_token,
    };
  }, []);

  const headingJsonToRows = useCallback(
    (heading_json: Record<string, number> | null | undefined): HeadingRow[] => {
      if (!heading_json) return [];
      return Object.entries(heading_json).map(([title, page]) => ({
        id: `${title}__${page}__${Math.random().toString(36).slice(2, 8)}`,
        title,
        page,
      }));
    },
    []
  );

  const rowsToHeadingJson = (rows: HeadingRow[]): Record<string, number> => {
    const obj: Record<string, number> = {};
    for (const r of rows) {
      const key = r.title.trim();
      if (!key) continue;
      const pageNum = Number(r.page);
      if (!pageNum || pageNum <= 0) continue;
      obj[key] = pageNum;
    }
    return obj;
  };

  useEffect(() => {
    const fetchAll = async () => {
      if (!fileId) return;
      setLoading(true);
      setError(null);
      setSaveMessage(null);
      try {
        const metaRes = await axios.get<ApiResponse<FileRowWithUploader>>(
          `${API_BASE}files/${fileId}`,
          { headers: getHeaders() }
        );
        if (!metaRes.data.success || !metaRes.data.data) {
          throw new Error(metaRes.data.error || "파일 정보를 불러오지 못했습니다.");
        }
        setFileMeta(metaRes.data.data);

        const riRes = await axios.get<ApiResponse<FileResourceIndex>>(
          `${API_BASE}files/${fileId}/resource-index`,
          { headers: getHeaders() }
        );
        if (!riRes.data.success || !riRes.data.data) {
          throw new Error(riRes.data.error || "resource_index 정보를 불러오지 못했습니다.");
        }
        setResource(riRes.data.data);
        setHeadingRows(headingJsonToRows(riRes.data.data.heading_json));
      } catch (e: any) {
        setError(e?.message || "데이터를 불러오지 못했습니다.");
      } finally {
        setLoading(false);
      }
    };
    fetchAll();
  }, [fileId, getHeaders, headingJsonToRows]);

  const headingReadOnly = useMemo(() => {
    if (!fileMeta) return true;
    if (myTier === null) return true;
    if (myTier === 0) return false;
    if (fileMeta.uploader_id !== userId) return true;
    return false;
  }, [fileMeta, myTier, userId]);

  const handleHeadingChange = (id: string, field: "title" | "page", value: string) => {
    if (headingReadOnly) return;
    setHeadingRows((prev) =>
      prev.map((row) =>
        row.id === id ? { ...row, [field]: field === "page" ? Number(value) || 0 : value } : row
      )
    );
  };

  const handleAddHeadingRow = () => {
    if (headingReadOnly) return;
    setHeadingRows((prev) => [...prev, { id: `new_${Date.now()}`, title: "", page: 1 }]);
  };

  const handleRemoveHeadingRow = (id: string) => {
    if (headingReadOnly) return;
    setHeadingRows((prev) => prev.filter((row) => row.id !== id));
  };

  const handleSaveHeading = async () => {
    if (!fileId || headingReadOnly) return;
    setSaving(true);
    setError(null);
    setSaveMessage(null);
    try {
      const heading_json = rowsToHeadingJson(headingRows);
      await axios.put<ApiResponse>(
        `${API_BASE}files/${fileId}/heading-json`,
        { heading_json },
        { headers: getHeaders() }
      );
      setSaveMessage("heading_json이 저장되었습니다.");
    } catch (e: any) {
      setError(e?.message || "heading_json 저장에 실패했습니다.");
    } finally {
      setSaving(false);
    }
  };

  const contentPreview = useMemo(() => {
    if (!resource?.content_string_list) return [];
    return resource.content_string_list.map((text, idx) => {
      const trimmed = text ?? "";
      const slice = trimmed.length > 100 ? trimmed.slice(0, 100) + "…" : trimmed;
      return { index: idx, preview: slice };
    });
  }, [resource]);

  return (
    <Box sx={{ p: 2 }}>
      <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 2 }}>
        <IconButton onClick={() => navigate(-1)} size="small"><ArrowBackIcon /></IconButton>
        <Typography variant="h6" sx={{ fontWeight: 800 }}>파일 상세</Typography>
        <Box sx={{ flexGrow: 1 }} />
        {fileMeta?.status && <Chip label={fileMeta.status} size="small" variant="outlined" />}
      </Stack>

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {saveMessage && <Alert severity="success" sx={{ mb: 2 }}>{saveMessage}</Alert>}

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 6 }}><CircularProgress /></Box>
      ) : (
        fileMeta && resource && (
          <Stack spacing={2}>
            <Paper variant="outlined" sx={{ p: 2 }}>
              <Stack direction="row" spacing={1} alignItems="center" sx={{ mb: 1 }}>
                <DescriptionIcon fontSize="small" />
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>v{fileMeta.version_no} · {fileMeta.original_name}</Typography>
                <Chip label={(fileMeta.version_kind || "").toLowerCase() === "patch" ? "PATCH" : "FULL"} size="small" color={(fileMeta.version_kind || "").toLowerCase() === "patch" ? "warning" : "primary"} sx={{ ml: 1 }} />
                <Box sx={{ flexGrow: 1 }} />
              </Stack>
              <Stack direction="row" spacing={1} flexWrap="wrap">
                {fileMeta.effective_date && <Chip size="small" variant="outlined" label={`effective: ${formatUtc(fileMeta.effective_date)}`} />}
                {fileMeta.uploaded_at && <Chip size="small" variant="outlined" label={`uploaded: ${formatUtc(fileMeta.uploaded_at)}`} />}
                <Chip size="small" variant="outlined" label={`pages: ${resource.total_page_count}`} />
                <Chip size="small" variant="outlined" label={`processed: ${resource.current_page_progress}/${resource.total_page_count}`} />
                {myTier !== 0 && fileMeta.uploader_id !== userId && (
                  <Chip size="small" variant="outlined" color="warning" label="읽기 전용 (관리자/공용 문서)" />
                )}
              </Stack>
            </Paper>

            <Paper variant="outlined" sx={{ p: 2 }}>
              <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
                <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Heading (outline) 편집</Typography>
                <Box sx={{ flexGrow: 1 }} />
                {!headingReadOnly && <Button size="small" startIcon={<AddIcon />} onClick={handleAddHeadingRow}>행 추가</Button>}
                <Button size="small" variant="contained" startIcon={<SaveIcon />} onClick={handleSaveHeading} disabled={headingReadOnly || saving}>{saving ? "저장 중..." : "heading_json 저장"}</Button>
              </Stack>
              {headingReadOnly && <Alert severity="info" sx={{ mb: 2 }}>권한이 없어 목차를 수정할 수 없습니다. (읽기 전용)</Alert>}
              <Stack spacing={1} sx={{ mt: 1 }}>
                {headingRows.map((row) => (
                  <Stack key={row.id} direction={{ xs: "column", sm: "row" }} spacing={1} alignItems={{ xs: "flex-start", sm: "center" }}>
                    <TextField label="제목" size="small" fullWidth value={row.title} onChange={(e) => handleHeadingChange(row.id, "title", e.target.value)} InputProps={{ readOnly: headingReadOnly }} />
                    <TextField label="페이지 번호" size="small" type="number" sx={{ width: 140 }} value={row.page} onChange={(e) => handleHeadingChange(row.id, "page", e.target.value)} InputProps={{ readOnly: headingReadOnly }} />
                    {!headingReadOnly && <IconButton size="small" color="error" onClick={() => handleRemoveHeadingRow(row.id)}><DeleteOutlineIcon fontSize="small" /></IconButton>}
                  </Stack>
                ))}
              </Stack>
            </Paper>

            <Paper variant="outlined" sx={{ p: 2 }}>
              <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>내용 청크 프리뷰 (앞 100자, 조회용)</Typography>
              <Box sx={{ mt: 1, maxHeight: "400px", overflowY: "auto" }}>
                {contentPreview.map((c) => (
                  <Box key={c.index}>
                    <Divider sx={{ my: 1 }} />
                    <Typography variant="caption" color="text.secondary">#{c.index}</Typography>
                    <Typography variant="body2" sx={{ whiteSpace: "pre-wrap" }}>{c.preview}</Typography>
                  </Box>
                ))}
                {contentPreview.length === 0 && <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>content_string_list가 비어 있습니다.</Typography>}
              </Box>
            </Paper>
          </Stack>
        )
      )}
    </Box>
  );
};

export default FileDetailPage;